function JSONCheck(input) {
    if (typeof input !== 'string') {
        return false;
    }

    const trimmed = input.trim();

    if (trimmed.length === 0) {
        return false;
    }

    try {
        return JSON.parse(trimmed);
    } catch (err) {
        return false;
    }
}

export default JSONCheck;
